import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";

Vue.use(Router);
Vue.use(Meta);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue")
  },
  {
    path: "/rent/:id",
    name: "Rent",
    component: () =>
      import(/* webpackChunkName: "detail" */ "../views/Detail.vue"),
    props: {
      category: "rent"
    }
  },
  {
    path: "/sale/:id",
    name: "Sale",
    component: () =>
      import(/* webpackChunkName: "detail" */ "../views/Detail.vue"),
    props: {
      category: "sale"
    }
  }
];

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
